import * as yup from 'yup';

import { formatMessage } from 'utils/messages/utils';

export default yup.object().shape({
  measureName: yup.string().required(formatMessage('MEASURE_NAME_REQUIRED')),
  measureFieldType: yup.object().nullable().required(formatMessage('MEASURE_TYPE_REQUIRED')),
  measureFormatType: yup.object().nullable().required(formatMessage('MEASURE_FORMAT_REQUIRED'))
});
